import { Injectable } from '@angular/core';
import * as _ from "underscore"

@Injectable()
export class NavigationHistoryService {
    constructor() {
    }

    public setHistory(obj: Navigation) {
        try {
            //only when valid data
            //if (companyId > 0 && statementTypeId > 0 && userTypeId > 0) {
            if (obj && obj.Key && obj.StatementTypeId > 0) {

                let str = JSON.stringify(obj);
                sessionStorage.setItem(obj.Key, str);
            }
        }
        catch (err) {
            console.log(err);
        }
    }

    public getHistory(key: string): Navigation | null {
        try {
            var item: any = sessionStorage.getItem(key);

            if (item) {
                var navigationObj = JSON.parse(item) as Navigation;

                if (navigationObj.StatementTypeId > 0 || navigationObj.CompanyId > 0)
                    return navigationObj;
            }
        }
        catch (err) {
            console.log(err);
        }

        return null;
    }
}

export const NavigationSelectionKey = {
    ComplianceCertificate: "compliance.certificate.selection",
    ConsolidatedCertificate: "consolidated.certificate.selection",
    GenerateCertificate: "generate.certificate.selection",
    ComplianceStatement: "compliance.statement.selection",
    UserDelegation: "user.delegation.selection"
};

export class Navigation {
    public StatementTypeId: number;
    public CompanyId: number;
    public UserTypeId: number;
    public Key: string;
}